import {CustomAlertsCountResults} from 'app_api/projects/alerts/custom/types';
import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {CUSTOM_ALERT_TYPE} from 'common/widgets/alerts/custom-alert/constants';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint(projectId: string): string {
  return appApiUrl(`alerts/custom/alert-count`, {projectId});
}

export const customAlertsLimitClient: ApiResourceClient<CustomAlertsCountResults> = {
  index() {
    throw new Error(`customAlertsLimitClient does not support index queries`);
  },

  get(id: string) {
    return apiClient.hydratedGet<CustomAlertsCountResults>(
      buildEndpoint(id),
      {alert_type: CUSTOM_ALERT_TYPE.anomaly},
      {
        updateFetchCache: true,
      },
    );
  },

  purgeCache(id: string) {
    purgeFetchCache({everything: true, path: buildEndpoint(id)});
  },
};
